import script from "./training.vue?vue&type=script&setup=true&lang=js"
export * from "./training.vue?vue&type=script&setup=true&lang=js"

import "./training.vue?vue&type=style&index=0&id=e2cab5c6&scoped=true&lang=css"

import exportComponent from "F:\\workspace\\custom\\sdxlxh\\ShanDongXinLiZiXun\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e2cab5c6"]])

export default __exports__